import { useEffect, useState } from "react";

import Loader from "@syntensor/common/components/loader";
import { filterItemsBySearch } from "@syntensor/common/utils/search_utils";
import SearchForm from "@syntensor/common/components/search_form";
import { fetchGroups } from "@syntensor/common/data/fetch_data";
import getCopy from "@syntensor/common/data/copy";
import { IGroup } from "@syntensor/common/types";

import classes from "./groups.module.css";
import GroupBox from "./groupbox";
import Button from "@syntensor/common/components/button";
import { IsUserInAdminGroup } from "../auth/auth_context";

export default function Groups() {
  const [isLoading, setIsLoading] = useState(true);
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [search, setSearch] = useState<string>("");
  const isUserInAdminGroup = IsUserInAdminGroup();

  async function asyncFetch() {
    try {
      setIsLoading(true);
      const groups = await fetchGroups();

      setGroups(groups);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    asyncFetch();
  }, []);

  const handleSearch = (search: string) => {
    setSearch(search);
  };

  const handleChange = (newSearch: string) => {
    if (search && newSearch === "") {
      //  cleared input box
      setSearch("");
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  //  we might be rendering subset of the components
  //  due to search term being input in the search form
  const filteredGroups = search
    ? (filterItemsBySearch(groups, search) as IGroup[])
    : groups;

  const hasResults = filteredGroups && filteredGroups.length > 0;

  return (
    <div className={classes.projects}>
      <div className={classes.header}>
        <h2
          data-testid="projectsBreadcrumb"
          className={classes.headerTitle}
          dangerouslySetInnerHTML={{
            __html: getCopy("groups_overview_title"),
          }}
        />
        <div style={{ marginLeft: "auto" }}>
          {isUserInAdminGroup ? (
            <Button to={`/groups/create`} role="subtle">
              {getCopy("groups_overview_new-group")}
            </Button>
          ) : (
            <p>&nbsp;</p>
          )}
        </div>
      </div>
      <div className={classes.search}>
        <SearchForm
          onSearch={handleSearch}
          onChange={handleChange}
          placeholder={getCopy("groups_overview_search-placeholder")}
          debounceDelay={0}
          name="search-groups"
          minChars={1}
          size="small"
        />
      </div>
      <div className={classes.list}>
        <ul className={classes.grid}>
          {filteredGroups &&
            filteredGroups.map((group) => {
              return (
                <li key={group.id}>
                  <GroupBox
                    {...group}
                    onDelete={group.roleId === 1 ? asyncFetch : null}
                    onClone={group.roleId === 1}
                  />
                </li>
              );
            })}
        </ul>
        {!hasResults && <div>{getCopy("groups_overview_empty-result")}</div>}
      </div>
    </div>
  );
}
